import { string, object, boolean, } from 'yup';
const accountNumberLengthMessage = 'Your account number must be 8 digits';
const sortCodeLengthMessage = 'Your sort code must be 6 digits';
const termsAndConditionsMessage = 'Please accept the terms and conditions';
const directDebit = {
    accountName: string().required('Please enter your account holder name'),
    accountNumber: string()
        .min(8, accountNumberLengthMessage)
        .max(8, accountNumberLengthMessage)
        .required('Please enter your account number'),
    sortCode: string()
        .min(6, sortCodeLengthMessage)
        .max(6, sortCodeLengthMessage)
        .required('Please enter your sort code'),
    termsAccepted: boolean()
        .required(termsAndConditionsMessage)
        .oneOf([true], termsAndConditionsMessage),
    directDebitAccepted: boolean()
        .required(termsAndConditionsMessage)
        .oneOf([true], termsAndConditionsMessage),
};
export const directDebitSchema = object(directDebit);
